import _ from 'lodash';
import $api from '../api';

export default {
    props: ['fV', 'fName', 'value', 'name', 'required', 'type', 'label', 'length',
        'type', 'appendIcon', 'appendIconCb'],
    methods: {
        emit(text) {
            this.$emit("input", text);
            this.touch();
        },
        getV() {
            return this.fV;

        },
        getFormObj(){
            if(_.isArray(this.fName)){
                 var out = this.getV(); 
                for(var i in this.fName){
                    out = out[this.fName[i]];
                }
                return out;
            }else{
               return this.getV()[this.fName];
            }
        },
        touch() {
            if (this.getFormObj()) {
                this.getFormObj().$touch();
            }
        },
        tr(m, n) {            
            var p = this.$parent;
            while ( p && !p.tr) {
                p = p.$parent;
            }
            if (p && p.tr) {
                return p.tr(m, n);
            }
            return $api.messages.msg(m, null, n);
        }
    },
    created: () => {

    },

    computed: {
        errorMsgs() {
            const errors = [];
            if (this.getFormObj()) {
                if (!this.getFormObj().$dirty || this.getFormObj().$pending) {
                    return errors;
                }

                for (var n in this.getFormObj().$params) {
                    if (!this.getFormObj()[n]) {
                        errors.push(this.tr(n, this.fName));
                    }
                }
            }
            return errors;
        }
    },
    data: () => ({
            //errorMsgs: []
        })
}





// WEBPACK FOOTER //
// ./src/public_app/elements/InputBase.js